import { IRootState } from '../../../store'
import { IPhoneDetail } from '../store/options.types'

export const getPhoneDetailSelector = (state: IRootState): IPhoneDetail | null | undefined =>
  state.options.patientDemographicsOptions.phoneDetail
